<div class="p-grid" *ngIf="formErrorMessages.length > 0 || controlErrorMessages.length > 0">
    <div class="p-col-12">      
        <div *ngIf="showClearButton" style="float: right !important;">
            <button type="button" pButton pRipple (click)="resetForm()" icon="pi pi-times" class="p-button-warning"></button>          
        </div>
        <div style="margin-top: 2.5rem;">
            <p-messages [(value)]="msgs" [enableService]="false" [closable]="!showClearButton"></p-messages>
        </div>
    </div>
</div>
